/**
 * Interop for the `rrule` package: Node loads its CommonJS build (exports live on `default`),
 * bundlers load its ESM build (named exports). This shim works in both environments.
 */
import * as rruleModule from 'rrule';
import type { RRule as RRuleClass } from 'rrule';

type RRuleModule = { RRule?: typeof RRuleClass; default?: { RRule: typeof RRuleClass } };

const mod = rruleModule as unknown as RRuleModule;
const resolved = mod.RRule ?? mod.default?.RRule;
if (!resolved) throw new Error('rrule: RRule export not found');

export const RRule: typeof RRuleClass = resolved;
export type { Options as RRuleOptions } from 'rrule';
